export const addressList = (theme) => ({
  root: {},
  addressContainerMobile: {
    padding: 32,
  },
  autocompleteCustom: {
    '& label + .MuiInput-formControl': {
      marginTop: '0 !important',
    },
  },
  addressPanel: {
    fontFamily: 'Spezia',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  inputAddress: {
    width: '100%',
  },
  labelAddr: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.customPalette.neutralGy05,
    // paddingLeft: theme.spacing(1),
    textTransform: 'capitalize',
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
      fontWeight: 'normal',
      // paddingLeft: theme.spacing(2),
      textTransform: 'uppercase',
    },
  },
  gridAction: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addNewButton: {
    backgroundColor: 'transparent !important',
    fontFamily: 'Spezia',
    border: '1px solid',
    borderColor: theme.customPalette.secondaryYellowYButtons,
    color: theme.customPalette.secondaryYellowYButtons + '!important',
    fontWeight: 'bold',
    fontSize: '18px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:hover': {
      color: theme.customPalette.darkishPurple + '!important',
    },
  },
  defaultLabel: {
    position: 'absolute',
    top: '-14%',
    left: '2%',
    backgroundColor: '#fff',
    border: '1px solid' + theme.customPalette.darkishPurple,
    color: theme.customPalette.darkishPurple,
    padding: '2px 6px',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Spezia',
    display: 'none',
    height: 24,
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  summary: {
    border: '1px solid' + theme.customPalette.neutralGr03,
    // border: "none",
    // [theme.breakpoints.up("sm")]: {
    //     border: "1px solid" + theme.customPalette.secondaryYellowYButtons,
    // },
  },
  details: {
    border: '1px solid' + theme.customPalette.neutralGr03,
    borderTop: 'none',
    padding: theme.spacing(0),
    // border: "none",
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5),
    },
  },
  actions: {},
  passwordContainer: {
    marginTop: theme.spacing(1),
  },
  summaryContainer: {
    // paddingTop: "16px",
    // paddingBottom: "16px",
    margin: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  prefixInput: {
    width: '100% !important',
    padding: '14px 55px !important',
    borderTop: 0,
    borderRight: 0,
    borderLeft: 0,
    '&$hover': {
      borderTop: 0,
      borderRight: 0,
      borderLeft: 0,
    },
    '&$focus': {
      borderTop: 0,
      borderRight: 0,
      borderLeft: 0,
    },
    ...theme.overrides.MuiFilledInput.root,
  },
  prefixInputContainer: {
    marginTop: 17,
  },
  isDefault: {
    backgroundColor: '#bfbfbf',
  },
  labelWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    height: '100%',
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingBottom: theme.spacing(2),
      borderBottom: `1px solid white`,
    },
  },
  summaryElement: { padding: '16px 8px' },
  errorPhone: {
    fontSize: 12,
    color: theme.customPalette.coral,
  },
  outlinedHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.customPalette.neutralGr03}`,
    paddingTop: '16px',
    paddingBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
    },
  },
  /* Styles applied to the root element if `variant="filled"`. */
  filled: {},
  /* Styles applied to the root element if `variant="outlined"`. */
  outlined: {
    '& $summaryElement': {
      padding: theme.spacing(3, 2),
    },
  },
  expanded: {
    backgroundColor: 'red',
  },
});
